import IColumn from "models/IColumn";

export const getColumns = (local = "nl"): IColumn[] => [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    title: "DATE",
    fixedWidth: 164,
    key: "DateFrom",
    type: "date",
    visible: true
  },
  {
    title: `TITLE`,
    key: `Title_${local}`,
    visible: true
  },
  {
    title: `TEXT`,
    key: `Text_${local}`,
    visible: true
  }
];
